import '../../assets/components/Button/Button.css';//#region lib/components/Button/Button.module.css
var e = "_iconStart_1uu9x_44", t = "_iconEnd_1uu9x_45", n = {
	"button-defaults": "_button-defaults_1uu9x_1",
	"button-content": "_button-content_1uu9x_32",
	"color-primary": "_color-primary_1uu9x_40",
	iconStart: e,
	iconEnd: t,
	"color-secondary": "_color-secondary_1uu9x_59",
	"color-destructive": "_color-destructive_1uu9x_77",
	"color-neutral": "_color-neutral_1uu9x_95",
	"color-translucent": "_color-translucent_1uu9x_120",
	"size-sm": "_size-sm_1uu9x_138",
	"size-md": "_size-md_1uu9x_145",
	"size-lg": "_size-lg_1uu9x_152",
	"size-xl": "_size-xl_1uu9x_159",
	"shape-rounded-corners": "_shape-rounded-corners_1uu9x_172",
	"shape-pill": "_shape-pill_1uu9x_176",
	"no-border": "_no-border_1uu9x_180"
};
//#endregion
export { n as default, t as iconEnd, e as iconStart };
